/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ButtonDesignClass {
  DEFAULT = 'w-full',
  PRIMARY = 'p-button p-button-primary',
  PRIMARY_GRID_BUTTON = 'p-button p-button-primary grid-button',
  PRIMARY_OUTLINED = 'p-button p-button-primary p-button-outlined',
  PRIMARY_TEXT = 'p-button p-button-primary p-button-text',
  PRIMARY_DROPDOWN = 'p-button p-button-primary p-0 w-full align-left',
  PRIMARY_MENU = 'p-button p-button-primary w-full justify-content-center',
  SECONDARY = 'p-button p-button-secondary',
  SECONDARY_OUTLINED = 'p-button p-button-secondary p-button-outlined',
  SECONDARY_TEXT = 'p-button p-button-secondary p-button-text',
  SUCCESS = 'p-button p-button-success',
  SUCCESS_OUTLINED = 'p-button p-button-success p-button-outlined',
  SUCCESS_TEXT = 'p-button p-button-success p-button-text',
  INFO = 'p-button p-button-info',
  INFO_OUTLINED = 'p-button p-button-info p-button-outlined',
  INFO_TEXT = 'p-button p-button-info p-button-text',
  WARNING = 'p-button p-button-warning',
  WARNING_OUTLINED = 'p-button p-button-warning p-button-outlined',
  WARNING_TEXT = 'p-button p-button-warning p-button-text',
  HELP = 'p-button p-button-help',
  HELP_OUTLINED = 'p-button p-button-help p-button-outlined',
  HELP_TEXT = 'p-button p-button-help p-button-text',
  DANGER = 'p-button p-button-danger',
  DANGER_GRID_BUTTON = 'p-button p-button-danger grid-button',
  DANGER_FUllHEIGHT = 'p-button p-button-danger full-height',
  DANGER_OUTLINED = 'p-button p-button-danger p-button-outlined',
  DANGER_TEXT = 'p-button p-button-danger p-button-text',
  LINK = 'p-button p-button-link p-0 select-text',
  MENU_DANGER = 'text-danger',
  HANDLE_OUTLINED = 'p-button p-button-secondary p-button-text p-button-xsm',
  HANDLE_OUTLINED_WHITE = 'p-button p-button-secondary p-button-text p-button-xsm',
  HANDLE_TEXT = 'p-button p-button-secondary p-button-text p-button-xsm',
  PANEL_BIG_TEXT = 'p-button p-button-secondary p-button-text medsurf-panel-close-button',
  PRIMARY_SMALL = 'p-button p-button-primary p-button-xsm',
  PRIMARY_SMALL_OUTLINED = 'p-button p-button-primary p-button-outlined p-button-xsm',
  PRIMARY_SMALL_TEXT = 'p-button p-button-primary p-button-text p-button-xsm',
  SECONDARY_SMALL = 'p-button p-button-secondary p-button-xsm',
  SECONDARY_SMALL_OUTLINED = 'p-button p-button-secondary p-button-outlined p-button-xsm',
  SECONDARY_SMALL_TEXT = 'p-button p-button-secondary p-button-text p-button-xsm',
  SECONDARY_SMALL_OUTLINED_TREE = 'p-button p-button-secondary p-button-outlined p-button-xsm w-full justify-content-center',
  DANGER_SMALL = 'p-button p-button-danger p-button-xsm',
  DANGER_SMALL_OUTLINED = 'p-button p-button-danger p-button-outlined p-button-xsm',
  DANGER_SMALL_TEXT = 'p-button p-button-danger p-button-text p-button-xsm',
  PDF_DOWNLOAD = 'p-button text-left column-gap-2 font-normal'
}

export enum ButtonDefaultIcons {
  ADD = 'fal fa-plus',
  ALIGN_LEFT = 'fal fa-thin fa-align-left',
  ALIGN_CENTER = 'fal fa-thin fa-align-center',
  ALIGN_RIGHT = 'fal fa-thin fa-align-right',
  ANNOTATIONS = 'fal fa-location-dot',
  ANNOTATION_MARKER = 'fal fa-map-pin',
  ANNOTATION_TEXT = 'fal fa-text',
  ANNOTATION_KEYMAP = 'fal fa-list-ol',
  ANNOTATION_FREEFORM_FREE = 'fal fa-pen-nib',
  ANNOTATION_FREEFORM_INTERACTIVEAREA = 'fal fa-vector-polygon',
  ANNOTATION_FREEFORM_LINE = 'fal fa-dash',
  ANNOTATION_FREEFORM_RECTANGLE = 'fal fa-rectangle',
  ANNOTATION_FREEFORM_ELLIPSE = 'fal fa-circle',
  ANNOTATION_FREEFORM_ARROW = 'fal fa-arrow-left',
  ANNOTATION_FREEFORM_TRIANGLE = 'fal fa-triangle',
  ANNOTATION_FREEFORM_WEDGE = 'fal fa-light fa-location-arrow',
  ATTACH = 'fal fa-regular fa-link',
  BACK = 'fal fa-long-arrow-left',
  BOOKMARK = 'fal fa-bookmark',
  CHANGELOG = 'fal fa-solid fa-display-chart-up',
  CHECK = 'fal fa-check',
  COPY = 'fal fa-copy',
  COPYRIGHT = 'fal fa-light fa-copyright',
  DETACHED_SLIDES = 'fal fa-solid fa-link-slash',
  DETACH = 'fal fa-solid fa-link-slash',
  DOCUMENTATION = 'fal fa-light fa-book',
  DOWN = 'fal fa-regular fa-chevron-down',
  DOWNLOAD = 'fal fa-download',
  DOWNLOAD_LINK = ButtonDefaultIcons.DOWNLOAD + ' mx-2',
  DUPLICATE = 'fal fa-regular fa-clone',
  DUPLICATE_WITH_ANNOTATIONS = 'fal fa-regular fa-clone',
  DUPLICATE_AS_TRAINING = 'fal fa-regular fa-clone',
  DUPLICATE_AS_TRAINING_WITH_ANNOTATIONS = 'fal fa-regular fa-clone',
  EDIT = 'fal fa-pencil',
  ERROR = 'fal fa-circle-xmark',
  EYE = 'fal fa-eye',
  EYE_ARROW = 'fal fa-arrows-to-eye',
  EYE_SLASH = 'fal fa-eye-slash',
  EYE_DROPPER = 'fal fa-eye-dropper',
  FILE = 'fal fa fa-light fa-file',
  FILE_IMAGE = 'fal fa-file-image',
  GROUP = 'fal fa-regular fa-object-group',
  HOUSE = 'fal fa-regular fa-house',
  INFO = 'fal fa-circle-info',
  IMAGE = 'fal fa-light fa-image',
  KEY = 'fal fa-key-skeleton',
  IMPORT_DEEPZOOM = 'fal fa-solid fa-cloud-arrow-up',
  LAYER = 'fal fa-regular fa-layer-group',
  LEFT = 'fal fa-regular fa-chevron-left',
  LOCATE = 'fal fa-light fa-location-crosshairs',
  LOCK = 'fal fa-lock',
  LOG_ENTRY = 'fal fa-ballot',
  LOGOUT = 'fal fa-regular fa-right-from-bracket',
  MATOMO_STATS = 'fal fa-solid fa-chart-simple',
  MEDIA = 'fal fa-solid fa-photo-film-music',
  MEDIA_VISUAL = 'fal fa-solid fa-photo-film',
  MEDIA_AUDIO = 'fal fa-volume-up',
  MEDIA_DEFAULT = 'fal fa-text',
  MEDIA_DEEPZOOM = 'fal fa-th',
  MEDIA_DOCUMENT = 'fal fa-file',
  MEDIA_IMAGE = 'fal fa-image',
  MEDIA_VIDEO = 'fal fa-video',
  MENU = 'fal fa-bars',
  METADATA = 'fal fa-light fa-database',
  MINUS = 'fal fa-minus',
  MODALITY = 'fal fa-regular fa-circle-info',
  MOVE = 'fal fa-grip-dots-vertical pointer-events-none',
  NOTE = 'fal fa-solid fa-note',
  OPTIONS = 'fal fa-solid fa-ellipsis',
  PAGE_ELEARNING = 'fal fa-cube',
  PAGE_PIPE = 'fal fa-rectangle-vertical',
  PAGE_FOLDER = 'fal fa-folder',
  PAGE_GRID = 'fal fa-grip-dots', // or possible: f0al fa-rectangle-history0, or any collection icon (=> https://fontawesome.com/search?q=collection&o=r)
  PAGE_CASE = 'fal fa-briefcase-medical',
  PAGE_TRAINING = 'fal fa-question',
  PAGE_QUIZSTART = 'fal fa-clipboard-question',
  PAGE_VOCABULARY = 'fal fa-book-font',
  PAGE_SLIDE = 'fal fa-table-layout',
  PASTE = 'fal fa-paste',
  PASTE_MR_2 = 'fal fa-paste mr-2',
  PDF = 'fal fa-light fa-file-pdf',
  PRESENTATION = 'fal fa-presentation',
  PREVIEW = 'fal fa-arrow-up-right-from-square',
  PLUS = 'fal fa-plus',
  QUESTION = 'fal fa-light fa-question',
  QUESTION_SINGLE_CHOICE = 'fal fa-light fa-question',
  QUESTION_LONG_LIST = 'fal fa-light fa-question',
  QUESTION_MAPPING = 'fal fa-light fa-question',
  QUESTION_KPRIME = 'fal fa-light fa-question',
  QUESTION_TRUE_FALSE = 'fal fa-light fa-question',
  QUESTION_FREE_TEXT = 'fal fa-light fa-question',
  QUESTION_INDICATION = 'fal fa-light fa-question',
  RECTANGLE_VERTICAL_HISTORY = 'fal fa-light fa-rectangle-vertical-history',
  REFRESH = 'fal fa-refresh',
  REMOVE = 'fal fa-trash-can',
  RIGHT = 'fal fa-regular fa-chevron-right',
  UP = 'fal fa-regular fa-chevron-up',
  REDO = 'fal fa-redo',
  RELOAD = 'fal fa-arrows-rotate',
  SAVE = 'fal fa-save',
  SAVE_BIG = 'fal fa-3x fa-save',
  SEARCH = 'fal fa-regular fa-magnifying-glass',
  SEARCH_MEDIA = 'fal fa-regular fa-magnifying-glass-play',
  SELECTION_ADD = 'fal fa-square-check',
  SELECTION_REMOVE = 'fal fa-square-xmark',
  SHARE = 'fal fa-share',
  SHUFFLE = 'fal fa-shuffle',
  SIGN_POST = 'fal fa-light fa-sign-post',
  SORT_A_Z = 'fal fa-arrow-down-a-z',
  SPINNER = 'fal fa-spinner',
  STAIN = 'fal fa-light fa-palette',
  STAR = "fal fa-star",
  STATUS_DEFAULT = 'fal fa-circle-question text-warning',
  STATUS_DRAFT = 'fal fa-pencil',
  STATUS_IN_REVIEW = 'fal fa-file-search',
  STATUS_REVIEW_NOT_OK = 'fal fa-exclamation-square text-danger',
  STATUS_FINAL = 'fal fa-check-square text-success',
  SUCCESS = 'fal fa-check',
  TABLE_COLUMNS = 'fal fa-regular fa-table-columns',
  TEXT = 'fal fa-text',
  TH_LIST = 'fal fa-th-list',
  TIMES = 'fal fa-times',
  TIMES_MR_2 = 'fal fa-times mr-2',
  THEME = 'fal fa-regular fa-paint-roller',
  UNDO = 'fal fa-undo',
  UNLOCK = 'fal fa-unlock',
  UNLINK = 'fal fa-unlink',
  UPLOAD = 'fal fa-regular fa-cloud-arrow-up',
  UPLOAD_BIG = 'fal fa-3x fa-cloud-arrow-up',
  USER = 'fal fa-light fa-user',
  WARNING = 'fal fa-triangle-exclamation',
  WATERMARK_NONE = 'fal fa-trash-can',
  WATERMARK_TOP_LEFT = 'fal fa-arrow-up-left',
  WATERMARK_TOP_RIGHT = 'fal fa-arrow-up-right',
  WATERMARK_BOT_LEFT = 'fal fa-arrow-down-left',
  WATERMARK_BOT_RIGHT = 'fal fa-arrow-down-right',
}

export enum ButtonDefaultIconsStyle {
  INFO = ' text-blue-400',
  WARNING = ' text-yellow-400',
  DANGER = ' text-red-400',
  SUCCESS = ' text-green-400',
}

export const ButtonSolidStyle = " fa-solid";
